/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { ThemeProvider, jsx } from '@emotion/react';

import { type ReactNode, useMemo } from 'react';

import { useCourseraPlusProductOwnerships } from 'bundles/coursera-plus-common/utils/withCourseraPlusProductOwnerships';
import { LearnerProvider } from 'bundles/search-common/providers/LearnerProvider';
import RouterProvider from 'bundles/search-common/providers/RouterProvider';
import SearchProvider from 'bundles/search-common/providers/SearchProvider';
import { searchTheme } from 'bundles/search-common/searchTheme';
import { getSearchConfigs } from 'bundles/search-v2/hooks/useSearchConfigs';
import { getSEOSearchConfigs } from 'bundles/seo-entity-page/hooks/useSEOSearchConfigs';

export const SeoSearchProviderWrapper = ({
  children,
  isSEOEntityPage,
}: {
  children: ReactNode;
  isSEOEntityPage: boolean;
}) => {
  const { ownsCourseraPlus, ownsCourseraLite } = useCourseraPlusProductOwnerships();
  const searchConfigs = useMemo(() => {
    return isSEOEntityPage ? getSEOSearchConfigs(true) : getSearchConfigs(true);
  }, [isSEOEntityPage]);

  return (
    <ThemeProvider theme={searchTheme}>
      <RouterProvider>
        <SearchProvider searchConfigs={searchConfigs}>
          <LearnerProvider ownsCourseraPlus={ownsCourseraPlus} ownsCourseraLite={ownsCourseraLite}>
            {children}
          </LearnerProvider>
        </SearchProvider>
      </RouterProvider>
    </ThemeProvider>
  );
};
